export const SCROLLBAR_WIDTH = 7;
